export default {

	props: {
		/** 宽度 */
		width: {
			type: String
		},

		/** 外边距 */
		margin: {
			type: String
		},

		/** 内边距 */
		padding: {
			type: String
		},
	},

};
